
import Vue from 'vue';
import { ProgressBar } from './styles';

export default Vue.extend({
  name: 'Steps',
  components: {
    ProgressBar,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    onCurrent: {
      type: Function,
      default: null,
    },
  },
});
